import { useEffect } from "react";
import Modal from "../modal/Modal.component";
import Loading from "@components/loading/Loading";

const LoadingModal = ({ setPopupOpen }: any) => {
  return (
    <Modal
      isCloseHidden={true}
      setPopupOpen={setPopupOpen}
      style={{ width: "743px" }}
    >
      <div className="loadingio-spinner-rolling-vz439jxau8e">
        <Loading />
      </div>
    </Modal>
  );
};

export default LoadingModal;
